import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchProjectdossier } from '../services/fetchProjectdossier'

export { useProjectdossier, queryKey }

const queryKey = 'projectdossier'

const useProjectdossier = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isPending: isLoading,
    isError,
  } = useQuery({
    queryKey: [queryKey, id],
    queryFn: () => fetchProjectdossier({ id }),
    enabled: hasPermissions && !!id,
    refetchOnMount: true,
  })

  return {
    data,
    isLoading,
    isError,
  }
}
